import { Chip } from '@mui/material';
import type { AllocationStatus } from '../../../api/sitesApi';

interface AllocationStatusBadgeProps {
  status: AllocationStatus;
}

const statusConfig: Record<
  AllocationStatus,
  { label: string; color: 'info' | 'warning' | 'success' | 'error' | 'default' }
> = {
  InProgress: { label: 'In Progress', color: 'info' },
  Booked: { label: 'Pending', color: 'warning' },
  Approved: { label: 'Approved', color: 'success' },
  Rejected: { label: 'Rejected', color: 'error' },
  Cancelled: { label: 'Cancelled', color: 'default' },
};

export function AllocationStatusBadge({ status }: AllocationStatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <Chip
      label={config.label}
      color={config.color}
      size="small"
      sx={{ fontWeight: 500 }}
    />
  );
}
